export default "__VITE_ASSET__87195236__"